import { createStore } from "vuex";
import getters from "./getters";
import app from "./modules/app";
import settings from "./modules/settings";
import user from "./modules/user";
import game from "./modules/game";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  modules: {
    app,
    settings,
    user,
    game,
  },
  getters,
  plugins: [
    createPersistedState({
      // 存储方式：localStorage、sessionStorage、cookies
      storage: window.localStorage,
      // 存储的 key 的key值
      key: "store",
      reducer(state): any {
        return { ...state };
      },
    }),
  ],
});
